import { useTranslations } from "next-intl";

const baseDateRegex = /(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})/;
const invertedDateRegex = /(\d{4})(\/|-)(\d{1,2})(\/|-)(\d{1,2})/;
export const getQuarter = (date: Date | string, locale: string, t: any): string => {
  // const t = useTranslations();
  const [language, _] = locale.split("-");
  let conversionDate;
  let year;
  if (date instanceof Date) {
    conversionDate = date;
    year = conversionDate.getFullYear();
  } else {
    const baseRe = new RegExp(baseDateRegex);
    const invertedRe = new RegExp(invertedDateRegex);
    if (baseRe.test(date)) {
      const dateParts = date.match(baseDateRegex);
      if (dateParts && dateParts[1] && dateParts[3] && dateParts[5]) {
        year = Number(dateParts[5]);
        conversionDate = new Date(year, Number(dateParts[3]) - 1, Number(dateParts[1]));
      } else {
        return "";
      }
    } else if (invertedRe.test(date)) {
      const dateParts = date.match(invertedRe);
      if (dateParts && dateParts[1] && dateParts[3] && dateParts[5]) {
        year = Number(dateParts[1]);
        conversionDate = new Date(year, Number(dateParts[3]) - 1, Number(dateParts[5]));
      } else {
        return "";
      }
    } else {
      console.error("incorrect date", date);
      return "";
    }
  }
  if (conversionDate > new Date()) {
    const quarter = Math.floor((conversionDate.getMonth() + 3) / 3);
    const quarterKeyText = `label.quarter.Q${quarter}`;
    return language === "ar" ? `${year} / ${t(quarterKeyText)}` : `${t(quarterKeyText)} / ${year}`;
  } else {
    return "ready";
  }
};
export function parseDate(dateStr: Date | string): Date {
  if (dateStr instanceof Date) return dateStr;
  // Normalize "2026-07-07T12:00+02:00" → "2026-07-07T12:00:00+02:00"
  const normalized = dateStr?.replace(/(T\d{2}:\d{2})([-+Z])/, "$1:00$2");
  return new Date(normalized);
}

export function formatDate(dateStr: Date | string, lang: string = "en") {
  const date = parseDate(dateStr);

  if (isNaN(date.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat(lang, {
    day: "numeric",
    month: "short",
    year: "numeric",
  })?.format(date);
}

export function formatDateLong(dateStr: Date | string, lang: string = "en") {
  const date = parseDate(dateStr);

  if (isNaN(date.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat(lang, {
    day: "numeric",
    month: "long",
    year: "numeric",
  })?.format(date);
}

export function formatEventDate(dateStr: Date | string, lang: string = "en"): string {
  const date = parseDate(dateStr);
  if (isNaN(date.getTime())) return "";
  const day = date.getDate();
  const month = date.toLocaleString(lang, { month: "long" }).toUpperCase();
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

export function getFulDateYear(dateStr: Date | string, lang: string = "en") {
  // Cast string input to Date if it's a string
  const date = typeof dateStr === "string" ? new Date(dateStr) : dateStr;
  return date.getFullYear();
}
